import { Controller } from "@hotwired/stimulus";
import {DataTable} from "simple-datatables";

export default class extends Controller {
  static targets = ["table"];  // Define a target for the table element

  initialize() {
    this.initializeDataTable();
    this.csvDownloadButton = document.getElementById('csv-download-btn');
    this.csvDownloadButton.addEventListener('click', this.downloadCSV.bind(this));
  }

  initializeDataTable() {
    // Make sure the table is only initialized once
    if (this.tableTarget) {
      new DataTable(this.tableTarget, {
        paging: true,
        perPage: 10,  // Default records per page
        perPageSelect: [5, 10, 25, 50, ['All', 0]]
      });
    }
  }

  // Method to handle the CSV download
  downloadCSV(event) {
    event.preventDefault();
    const table = this.tableTarget;

    const rows = Array.from(table.querySelectorAll('tr'));
    const csvData = [];

    // Add table header row to CSV data
    const headers = Array.from(rows[0].querySelectorAll('th'))
      .map(th => th.textContent.trim());
    csvData.push(headers.join(','));

    // Loop through all table rows and extract data
    rows.slice(1).forEach(row => {
      const rowData = Array.from(row.querySelectorAll('td'))
        .map(td => td.textContent.trim());
      if (rowData.length > 0) {  // Only add rows with data
        csvData.push(rowData.join(','));
      }
    });

    // Create CSV content and trigger download
    const csvFile = new Blob([csvData.join('\n')], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(csvFile);
    link.download = 'results.csv'; // You can change the file name here
    link.click();
  }
}